
import { useEffect, useState } from "react";
import { Grid, Paper } from "@mui/material"
import { LayoutCrearDoc } from "../../layouts"
import { CarritoVacio, CardsComprarAhora, BotonesDeCompletarOrden, InformacionCliente } from "../components";
import { BackdropScreen } from "../../components";
import { PagoOrdenOp } from "../views";
import { useAuthStore, useFormOpStore, useGlobalValueStore, useUsuariosStore } from "../../../stores";
import { useListCarritoXUser } from "../../../hooks/cache";
import { separadorMillares, usePrecioCarritoXRole } from "../../../hooks";
import { roleCompra } from "../../../data";
import { startComprarOP } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";

import Swal from "sweetalert2";




export const ComprarAhora = () => {

    const { usuario } = useAuthStore();
    const queryClient = useQueryClient();
    const { formOp, resetForm, setFormOp } = useFormOpStore();
    const { data } = useListCarritoXUser(usuario.id);
    const { iva, view, cambiarIva, cambioRolVenta } = useGlobalValueStore();
    const { precioTotalSegunRol, obtenerPreciosCarritoIva } = usePrecioCarritoXRole();
    const { activarUserVenta, usuarioVenta } = useUsuariosStore();
    const titulo = (view) ? `Venta realizada a ${view}` : 'Por favor seleccione tipo de cliente';

    const [cargando, setCargando] = useState(false);

    
    useEffect(() => {
        if(!data || data.length < 1) return;
        const precios = obtenerPreciosCarritoIva(data);
        if(precios) {
            setFormOp({
                view: view,
                totalCliente: precios.cliente,
                totalDistri: precios.distri,
                totalPublicista: precios.publicista,
                totalEmpresa: precios.empresa,
                totalOrden: precios.totalView,
                iva: precios.valorIVA,
                quienCompra: usuarioVenta?.id || null,
            });
        }
    }, [data, iva, view, usuarioVenta?.id]);


    const handleCrearOp = async() => {
        const { isConfirmed } = await Swal.fire({
            title: 'Hacer compra',
            text: `¿Está seguro de realizar esta compra?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, Realizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await startComprarOP(formOp);
        setCargando(false);
        if( resp ) { 
            await queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });
            resetForm();
            cambiarIva(false);
            activarUserVenta(null);
            cambioRolVenta(null);
        }
    }    




    return (
        <LayoutCrearDoc titulo='Pagar Orden' subtitulo={titulo} add={false}>
            <BackdropScreen cargando={cargando} titulo='Espere por favor estamos generando su orden de pedido...' />

            {(data?.length > 0)
            ?   <Grid container mt={5}>
                    <Grid item xs={12} md={7} sx={{ pr:{xs:0, md:3}, alignSelf:"flex-start"}}>
                        <CardsComprarAhora 
                            carritoCompra={data || []} 
                            urlCotiz="/super/cotizacion" 
                            urlDetalle="/super/detalle-item"
                            urlModificar="/super/detalle-producto" 
                        />

                        <Paper sx={{mt:2, p:2, height:'50px', display:'flex', alignItems:'center', justifyContent:'end'}}>
                            { `Total ${roleCompra[view]}: $${ separadorMillares(precioTotalSegunRol(data)) }` }
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={5} sx={{mt:{xs:5, md:0},}}>
                        {usuarioVenta && <InformacionCliente urlEditar="/super/checkout" /> }

                        <Grid item xs={12} sx={{ p:2, background:'#1E1E1E', borderRadius:'10px', alignSelf:"flex-start"}}>
                            <PagoOrdenOp  data={data} />
                            <BotonesDeCompletarOrden funcion={handleCrearOp} url="/super/checkout" />
                        </Grid>
                    </Grid>
                </Grid>

            :   <CarritoVacio />
            }
        </LayoutCrearDoc>
    )

}
